import React from 'react';
import './PromoBar.css';

const PROMO_ITEMS = [
  { badge: 'SIBLING DEAL', text: '10% Off for 2nd Child' },
  { badge: 'FREE SHIPPING',  text: 'DIY Kits Delivered Free to Your Doorstep' },
  { badge: 'CERTIFIED', text: 'Industry-backed ibots Certificates for Every Course' },
];

function PromoBar() {
  return (
    <div className="promobar">
      <div className="promobar__track">
        {[...PROMO_ITEMS, ...PROMO_ITEMS].map((item, i) => (
          <span key={i} className="promobar__item">
            <span className="promobar__emoji">{item.icon}</span>
            <span className="promobar__badge">{item.badge}</span>
            <span className="promobar__text">{item.text}</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default PromoBar;